function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "53312569-99AC-4DDC-93F7-AAA95F971B0D");
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lodge-enquiry",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lodge-enq-lodged-open-MD",
  transform: "translate(-660.000000, -694.000000)",
  stroke: "#FDA805"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19",
  transform: "translate(640.000000, 680.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icon/utility/24/electricity-circle",
  transform: "translate(20.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3032028,5.50553806 C14.2979494,5.51756336 14.2923697,5.53003159 14.2870057,5.54289923 L14.2870057,5.54289923 L12.7292547,9.4703582 L16.497788,9.4703582 C16.4887531,9.51263108 16.4624239,9.55713102 16.4266654,9.59993752 L16.4266654,9.59993752 L9.869,17.731 L11.6931262,11.910025 L8.49346119,11.910025 C8.5004702,11.8748511 8.5152874,11.8353914 8.527748,11.7943026 L8.527748,11.7943026 L10.5611008,5.74294704 Z",
  id: "Path",
  fillRule: "nonzero"
})))));
const SvgUiIconUtility24ElectricityCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24ElectricityCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-electricity-circle.53c43cf3.svg";
export { ForwardRef as ReactComponent };